import { bikeConfigFromParams } from './utils/bike-config'
import { decode as decodeQueryParams } from './utils/query-params'
import { listBaseModels, getDefaultPopover } from './utils/bike-schema'
import { BikeAngle, BikeConfig, RenderCustomizerOptions, State } from 'shared'

const initialState = (opts: RenderCustomizerOptions): State => {
  const { lang, isBikeOnlyLayout, isPdfLayout, isPdfBikeOnlyLayout } = opts

  let { currency: currencyCode, viewportHeightDelta } = opts
  currencyCode = currencyCode || 'DKK'

  // Use default for velorbis.dk if not set at all
  if (viewportHeightDelta === undefined) {
    viewportHeightDelta = -160
  }

  // Parse bike config
  const bikeConfigParams = decodeQueryParams(window.location.search)
  if (!bikeConfigParams.base_model_id) {
    bikeConfigParams.base_model_id = listBaseModels()[0].id
  }
  const bikeConfig: BikeConfig = bikeConfigFromParams(bikeConfigParams)
  const initialState: State = {
    lang,
    currencyCode,
    viewportHeightDelta,
    isBikeOnlyLayout,
    isPdfLayout,
    isPdfBikeOnlyLayout,
    bikeConfigPristine: true,
    bikeConfig: {
      ...bikeConfig,
      angle: (bikeConfig.angle as BikeAngle) || 'none',
      initials:
        bikeConfigParams.initials === 'undefined' ||
        bikeConfigParams.initials == undefined
          ? 'undefined'
          : bikeConfigParams.initials
    },
    bikeImage: {
      loaded: false,
      loading: false,
      highlightedComponentId: null,
      choices: [],
      logos: []
    },
    quantity: 1,
    quantityRaw: '1',
    popover: getDefaultPopover(bikeConfig.baseModelId),
    optionColor: {
      componentId: null,
      optionId: null
    },
    options: {
      componentId: null
    },
    addToCart: {
      errors: null, //array of strings
      submitting: false
    },
    inquiry: {
      errors: null, //array of strings
      fromName: '',
      fromEmail: '',
      fromPhone: '',
      fromAddress: '',
      message: '',
      submitting: false,
      done: false
    },
    share: {
      errors: null, //array of strings
      fromName: '',
      fromEmail: '',
      toName: '',
      toEmail: '',
      message: '',
      submitting: false,
      done: false
    },
    getQuote: {
      errors: null, // array of strings
      quantity: 1,
      companyName: '',
      companyAddressLine1: '',
      companyAddressLine2: '',
      companyCountry: '',
      companyVatNo: '',
      companyEmail: '',
      companyTelephone: '',
      contactPerson: '',
      comments: '',
      submitting: false,
      done: false
    },
    uncombinables: [],
    components: [],
    pdfOnly: false,
    latestPickedRals: [],
    specifications: true,
    specification: false,
    history: [],
    fullHistory: [],
    undoCounter: 0,
    undoed: false,
    disclaimer: false,
    cartDisclaimer: false,
    defaultLogo: true
  }
  return initialState
}

export default initialState
